import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { PtoPolicyFeatureComponent } from './pto-policy-feature/pto-policy-feature.component';
const log = new LoggingService();

export const PtoPolicyRoute: Ng2StateDeclaration = {
    name: 'ptopolicy',
    url: '/ptopolicy',
    data: { requiresAuth: true },

    component: PtoPolicyFeatureComponent
};
